module.exports = __webpack_public_path__ + "media/images/ohap_course_icon_gray-d9c7151d3750e2f14942adbe4d3bbbd7.png";